// Mapping tables extracted from convert.ge/ge/text.shtml; see SOURCES.md for attribution and license.
export const data = {
  names: [
    "_eng_",
    "_standart_",
    "_utf8_",
    "_utf8_UpperCase_",
    "Manuchari",
    "racxa",
    "GeoFinder",
    "RGEO",
    "utf",
    "UTFnoLat",
    "RUSGANLAGEBA",
    "AcadNusx",
    "erti",
    "Rusuli",
    "aaa",
    "ENGRUS",
    "geo",
    "AXTEL",
    "Antiqua",
    "LSI",
    "UniToMtavr",
    "ENGTHAI",
    "kolkheti",
    "odiSi",
    "password",
    "hhh",
    "ichveulebrivi",
    "sylfaen",
    "ravi",
    "giorgi",
    "ibw",
    "MinusKolkheti",
    "test",
    "ORIS",
    "orrris",
    "GeoTimes",
    "ChveuNusx",
    "Ventura",
    "dato",
    "eng",
    "li",
    "zzzKolkhety",
    "Orisrus",
    "LUT",
    "GeorgianSPLat",
    "sacdeli",
    "dacomutf",
    "sylifaen",
    "Kolkhi",
    "georgian",
    "literaturulyAV",
    "literaturulyAVMTAVR",
    "LitNusx",
    "Gaugebari",
    "GeoArial",
    "Nagdi",
    "tmptmp",
    "FI",
    "KolkhetiTeleType",
    "azaazaza",
    "lat",
    "ANusxuri",
    "fuchlugi",
    "IPTVGeoOld",
    "IPTVGeo",
    "Hejsannn",
    "sylfaenG",
    "Dumbadze",
    "rarus",
    "sylfaenn",
    "sylfaennn",
    "zoom",
    "ACADEMIURIAV",
    "Academic",
    "SAIDANrusulidan",
    "SADqartunikodze",
    "Grigolia",
    "PDFtoENG",
    "New_to_UTF8",
    "Tariel_Putkaradze_Transliteration",
  ],
  tables: {
    _eng_: [
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      113,
      119,
      101,
      114,
      116,
      121,
      117,
      105,
      111,
      112,
      91,
      93,
      97,
      115,
      100,
      102,
      103,
      104,
      106,
      107,
      108,
      59,
      39,
      122,
      120,
      99,
      118,
      98,
      110,
      109,
      44,
      46,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      81,
      87,
      69,
      82,
      84,
      89,
      85,
      73,
      79,
      80,
      123,
      125,
      65,
      83,
      68,
      70,
      71,
      72,
      74,
      75,
      76,
      58,
      34,
      90,
      88,
      67,
      86,
      66,
      78,
      77,
      60,
      62,
      63,
      "",
    ],
    _standart_: [
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      216,
      223,
      196,
      210,
      212,
      218,
      214,
      201,
      207,
      208,
      91,
      93,
      192,
      211,
      195,
      215,
      194,
      228,
      227,
      202,
      203,
      59,
      39,
      198,
      225,
      221,
      197,
      193,
      205,
      204,
      44,
      46,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      81,
      224,
      69,
      217,
      200,
      89,
      85,
      73,
      79,
      80,
      123,
      125,
      65,
      219,
      68,
      70,
      71,
      72,
      209,
      75,
      76,
      58,
      34,
      222,
      88,
      220,
      86,
      66,
      78,
      77,
      60,
      62,
      63,
      "",
    ],
    _utf8_: [
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      4325,
      4332,
      4308,
      4320,
      4322,
      4327,
      4323,
      4312,
      4317,
      4318,
      91,
      93,
      4304,
      4321,
      4307,
      4324,
      4306,
      4336,
      4335,
      4313,
      4314,
      59,
      39,
      4310,
      4334,
      4330,
      4309,
      4305,
      4316,
      4315,
      44,
      46,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      81,
      4333,
      69,
      4326,
      4311,
      89,
      85,
      73,
      79,
      80,
      123,
      125,
      65,
      4328,
      68,
      70,
      71,
      72,
      4319,
      75,
      76,
      58,
      34,
      4331,
      88,
      4329,
      86,
      66,
      78,
      77,
      60,
      62,
      63,
      "",
    ],
    _utf8_UpperCase_: [
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      4277,
      4284,
      4260,
      4272,
      4274,
      4279,
      4275,
      4264,
      4269,
      4270,
      91,
      93,
      4256,
      4273,
      4259,
      4276,
      4258,
      4288,
      4287,
      4265,
      4266,
      59,
      39,
      4262,
      4286,
      4282,
      4261,
      4257,
      4268,
      4267,
      44,
      46,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      81,
      4285,
      69,
      4278,
      4263,
      89,
      85,
      73,
      79,
      80,
      123,
      125,
      65,
      4280,
      68,
      70,
      71,
      72,
      4271,
      75,
      76,
      58,
      34,
      4283,
      88,
      4281,
      86,
      66,
      78,
      77,
      60,
      62,
      63,
      "",
    ],
    Manuchari: [
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      113,
      119,
      101,
      114,
      116,
      121,
      117,
      105,
      111,
      112,
      91,
      93,
      97,
      115,
      100,
      102,
      103,
      104,
      106,
      107,
      108,
      59,
      39,
      122,
      120,
      99,
      118,
      98,
      110,
      109,
      44,
      46,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      81,
      87,
      69,
      82,
      84,
      89,
      85,
      73,
      79,
      80,
      123,
      125,
      65,
      83,
      68,
      70,
      71,
      72,
      74,
      75,
      76,
      58,
      34,
      90,
      88,
      67,
      86,
      66,
      78,
      77,
      60,
      62,
      63,
      "",
    ],
    racxa: [
      42,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      113,
      119,
      101,
      114,
      116,
      121,
      117,
      105,
      111,
      112,
      91,
      93,
      97,
      115,
      100,
      102,
      103,
      104,
      106,
      107,
      108,
      59,
      39,
      122,
      120,
      99,
      118,
      98,
      110,
      109,
      44,
      46,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      81,
      87,
      69,
      82,
      84,
      89,
      85,
      73,
      79,
      80,
      123,
      125,
      65,
      83,
      68,
      70,
      71,
      72,
      74,
      75,
      76,
      58,
      34,
      90,
      88,
      67,
      86,
      66,
      78,
      77,
      60,
      62,
      63,
      "",
    ],
    GeoFinder: [
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      113,
      119,
      101,
      114,
      116,
      121,
      117,
      105,
      111,
      112,
      91,
      93,
      97,
      115,
      100,
      102,
      103,
      104,
      106,
      107,
      108,
      59,
      39,
      122,
      120,
      99,
      118,
      98,
      110,
      109,
      44,
      46,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      81,
      87,
      69,
      82,
      84,
      89,
      85,
      73,
      79,
      80,
      123,
      125,
      65,
      83,
      68,
      70,
      71,
      72,
      74,
      75,
      76,
      58,
      34,
      90,
      88,
      67,
      86,
      66,
      78,
      77,
      60,
      62,
      63,
      "",
    ],
    RGEO: [
      8222,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      8211,
      61,
      92,
      252,
      246,
      228,
      240,
      242,
      247,
      243,
      232,
      237,
      238,
      255,
      253,
      224,
      241,
      227,
      244,
      226,
      248,
      239,
      233,
      234,
      251,
      245,
      230,
      254,
      250,
      229,
      225,
      236,
      235,
      249,
      231,
      188,
      8222,
      33,
      167,
      189,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      8212,
      43,
      124,
      81,
      87,
      69,
      82,
      84,
      89,
      85,
      73,
      79,
      80,
      123,
      125,
      65,
      83,
      68,
      70,
      71,
      72,
      74,
      58,
      76,
      59,
      8220,
      90,
      88,
      67,
      86,
      66,
      78,
      77,
      44,
      46,
      63,
      "",
    ],
    utf: [
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      113,
      119,
      101,
      114,
      116,
      121,
      117,
      105,
      111,
      112,
      91,
      93,
      97,
      115,
      100,
      102,
      103,
      104,
      106,
      107,
      108,
      59,
      39,
      122,
      120,
      99,
      118,
      98,
      110,
      109,
      44,
      46,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      81,
      87,
      69,
      82,
      84,
      89,
      85,
      73,
      79,
      80,
      123,
      125,
      65,
      83,
      68,
      70,
      71,
      72,
      74,
      75,
      76,
      58,
      34,
      90,
      88,
      67,
      86,
      66,
      78,
      77,
      60,
      62,
      63,
      "",
    ],
    UTFnoLat: [
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      4325,
      4332,
      4308,
      4320,
      4322,
      4327,
      4323,
      4312,
      4317,
      4318,
      91,
      93,
      4304,
      4321,
      4307,
      4324,
      4306,
      4336,
      4335,
      4313,
      4314,
      59,
      8217,
      4310,
      4334,
      4330,
      4309,
      4305,
      4316,
      4315,
      44,
      46,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      4325,
      4333,
      4308,
      4326,
      4311,
      4337,
      4338,
      4339,
      4340,
      4341,
      123,
      125,
      4304,
      4328,
      4307,
      4324,
      4306,
      4336,
      4319,
      4313,
      4314,
      58,
      8221,
      4331,
      4334,
      4329,
      4309,
      4305,
      4316,
      4315,
      60,
      62,
      63,
      "",
    ],
    RUSGANLAGEBA: [
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      113,
      119,
      101,
      114,
      116,
      121,
      117,
      105,
      111,
      112,
      91,
      93,
      97,
      115,
      100,
      102,
      103,
      104,
      106,
      107,
      108,
      59,
      39,
      122,
      120,
      99,
      118,
      98,
      110,
      109,
      44,
      46,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      81,
      87,
      69,
      82,
      84,
      89,
      85,
      73,
      79,
      80,
      123,
      125,
      65,
      83,
      68,
      70,
      71,
      72,
      74,
      75,
      76,
      58,
      34,
      90,
      88,
      67,
      86,
      66,
      78,
      77,
      60,
      62,
      63,
      "",
    ],
    AcadNusx: [
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      113,
      119,
      101,
      114,
      116,
      121,
      117,
      105,
      111,
      112,
      91,
      93,
      97,
      115,
      100,
      102,
      103,
      104,
      106,
      107,
      108,
      59,
      39,
      122,
      120,
      99,
      118,
      98,
      110,
      109,
      44,
      46,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      81,
      87,
      69,
      82,
      84,
      89,
      85,
      73,
      79,
      80,
      123,
      125,
      65,
      83,
      68,
      70,
      71,
      72,
      74,
      75,
      76,
      58,
      34,
      90,
      88,
      67,
      86,
      66,
      78,
      77,
      60,
      62,
      63,
      "",
    ],
    erti: [
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      113,
      119,
      101,
      114,
      116,
      121,
      117,
      105,
      111,
      112,
      91,
      93,
      97,
      115,
      100,
      102,
      103,
      104,
      106,
      107,
      108,
      59,
      39,
      122,
      120,
      99,
      118,
      98,
      110,
      109,
      44,
      46,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      81,
      87,
      69,
      82,
      84,
      89,
      85,
      73,
      79,
      80,
      123,
      125,
      65,
      83,
      68,
      70,
      71,
      72,
      74,
      75,
      76,
      58,
      34,
      90,
      88,
      67,
      86,
      66,
      78,
      77,
      60,
      62,
      63,
      "",
    ],
    Rusuli: [
      1100,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      1095,
      1097,
      1077,
      1088,
      1090,
      1081,
      1091,
      1080,
      1086,
      1087,
      1099,
      1098,
      1072,
      1089,
      1076,
      1092,
      1075,
      1096,
      1078,
      1082,
      1083,
      1102,
      1101,
      1079,
      1093,
      1094,
      1074,
      1073,
      1085,
      1084,
      1103,
      46,
      44,
      34,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      1063,
      1065,
      1045,
      1056,
      1058,
      1049,
      1059,
      1048,
      1054,
      1055,
      1067,
      1066,
      1040,
      1057,
      1044,
      1060,
      1043,
      1064,
      1046,
      1050,
      1051,
      1070,
      1069,
      1047,
      1061,
      1062,
      1042,
      1041,
      1053,
      1052,
      1071,
      1105,
      63,
      "",
    ],
    aaa: [
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      113,
      119,
      101,
      114,
      116,
      121,
      117,
      105,
      111,
      112,
      91,
      93,
      97,
      115,
      100,
      102,
      103,
      104,
      106,
      107,
      108,
      59,
      8217,
      122,
      120,
      99,
      118,
      98,
      110,
      109,
      44,
      46,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      81,
      87,
      69,
      82,
      84,
      89,
      85,
      73,
      79,
      80,
      123,
      125,
      65,
      83,
      68,
      70,
      71,
      72,
      74,
      75,
      76,
      58,
      8221,
      90,
      88,
      67,
      86,
      66,
      78,
      77,
      60,
      62,
      63,
      "",
    ],
    ENGRUS: [
      1105,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      1081,
      1094,
      1091,
      1082,
      1077,
      1085,
      1075,
      1096,
      1097,
      1079,
      1093,
      1098,
      1092,
      1099,
      1074,
      1072,
      1087,
      1088,
      1086,
      1083,
      1076,
      1078,
      1101,
      1103,
      1095,
      1089,
      1084,
      1080,
      1090,
      1100,
      1073,
      1102,
      46,
      1025,
      33,
      34,
      8470,
      59,
      37,
      58,
      63,
      42,
      40,
      41,
      95,
      43,
      47,
      1049,
      1062,
      1059,
      1050,
      1045,
      1053,
      1043,
      1064,
      1065,
      1047,
      1061,
      1066,
      1060,
      1067,
      1042,
      1040,
      1055,
      1056,
      1054,
      1051,
      1044,
      1046,
      1069,
      1071,
      1063,
      1057,
      1052,
      1048,
      1058,
      1068,
      1041,
      1070,
      44,
      "",
    ],
    geo: [
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      113,
      119,
      101,
      114,
      116,
      121,
      117,
      105,
      111,
      112,
      91,
      93,
      97,
      115,
      100,
      102,
      103,
      104,
      106,
      107,
      108,
      59,
      39,
      122,
      120,
      99,
      118,
      98,
      110,
      109,
      44,
      46,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      81,
      87,
      69,
      82,
      84,
      89,
      85,
      73,
      79,
      80,
      123,
      125,
      65,
      83,
      68,
      70,
      71,
      72,
      74,
      75,
      76,
      58,
      34,
      90,
      88,
      67,
      86,
      66,
      78,
      77,
      60,
      62,
      63,
      "",
    ],
    AXTEL: [
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      229,
      236,
      164,
      224,
      226,
      231,
      227,
      168,
      173,
      174,
      91,
      93,
      160,
      225,
      163,
      228,
      162,
      240,
      239,
      169,
      170,
      59,
      39,
      166,
      238,
      234,
      165,
      161,
      172,
      171,
      44,
      46,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      81,
      237,
      69,
      230,
      167,
      89,
      85,
      73,
      79,
      80,
      123,
      125,
      65,
      232,
      68,
      70,
      71,
      72,
      175,
      75,
      76,
      58,
      34,
      235,
      88,
      233,
      86,
      66,
      78,
      77,
      60,
      62,
      63,
      "",
    ],
    Antiqua: [
      184,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      233,
      246,
      243,
      234,
      229,
      237,
      227,
      248,
      249,
      231,
      245,
      250,
      244,
      251,
      226,
      224,
      239,
      240,
      238,
      235,
      228,
      230,
      253,
      255,
      247,
      241,
      236,
      232,
      242,
      252,
      225,
      254,
      47,
      168,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      201,
      214,
      211,
      202,
      197,
      205,
      195,
      216,
      217,
      199,
      213,
      218,
      212,
      219,
      194,
      192,
      207,
      208,
      206,
      203,
      196,
      198,
      221,
      223,
      215,
      209,
      204,
      200,
      210,
      220,
      193,
      222,
      63,
      "",
    ],
    LSI: [
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      113,
      119,
      101,
      114,
      116,
      121,
      117,
      105,
      111,
      112,
      91,
      93,
      92,
      97,
      115,
      100,
      102,
      103,
      104,
      106,
      107,
      108,
      59,
      39,
      122,
      120,
      99,
      118,
      98,
      110,
      109,
      44,
      46,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      81,
      87,
      69,
      82,
      84,
      89,
      85,
      73,
      79,
      80,
      123,
      125,
      124,
      65,
      83,
      68,
      70,
      71,
      72,
      74,
      75,
      76,
      58,
      34,
      90,
      88,
      67,
      86,
      66,
      78,
      77,
      60,
      62,
      63,
      "",
    ],
    UniToMtavr: [
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      4277,
      4284,
      4260,
      4272,
      4274,
      4279,
      4275,
      4264,
      4269,
      4270,
      91,
      93,
      4256,
      4273,
      4259,
      4276,
      4258,
      4288,
      4287,
      4265,
      4266,
      59,
      39,
      4262,
      4286,
      4282,
      4261,
      4257,
      4268,
      4267,
      44,
      46,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      4277,
      4285,
      69,
      4278,
      4263,
      89,
      85,
      73,
      79,
      80,
      123,
      125,
      65,
      4280,
      68,
      70,
      71,
      72,
      4271,
      75,
      76,
      58,
      34,
      4283,
      88,
      4281,
      86,
      66,
      78,
      77,
      60,
      62,
      63,
      "",
    ],
    ENGTHAI: [
      95,
      3653,
      47,
      45,
      3616,
      3606,
      3640,
      3638,
      3588,
      3605,
      3592,
      3586,
      3594,
      3587,
      3654,
      3652,
      3635,
      3614,
      3632,
      3633,
      3637,
      3619,
      3609,
      3618,
      3610,
      3621,
      3615,
      3627,
      3585,
      3604,
      3648,
      3657,
      3656,
      3634,
      3626,
      3623,
      3591,
      3612,
      3611,
      3649,
      3629,
      3636,
      3639,
      3607,
      3617,
      3651,
      3613,
      37,
      43,
      3665,
      3666,
      3667,
      3668,
      3641,
      3647,
      3669,
      3670,
      3671,
      3672,
      3673,
      3589,
      3664,
      34,
      3598,
      3601,
      3608,
      3661,
      3658,
      3603,
      3631,
      3597,
      3600,
      44,
      3620,
      3590,
      3599,
      3650,
      3596,
      3655,
      3659,
      3625,
      3624,
      3595,
      46,
      40,
      41,
      3593,
      3630,
      3642,
      3660,
      63,
      3602,
      3628,
      3622,
      "",
    ],
    kolkheti: [
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      225,
      249,
      229,
      238,
      252,
      241,
      243,
      242,
      235,
      240,
      91,
      93,
      239,
      236,
      230,
      244,
      227,
      1105,
      246,
      234,
      228,
      59,
      39,
      231,
      245,
      250,
      226,
      254,
      237,
      232,
      44,
      46,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      193,
      217,
      197,
      206,
      220,
      209,
      211,
      210,
      203,
      208,
      123,
      125,
      207,
      204,
      198,
      212,
      195,
      1025,
      214,
      202,
      196,
      58,
      34,
      199,
      213,
      218,
      194,
      222,
      205,
      200,
      60,
      62,
      63,
      "",
    ],
    odiSi: [
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      113,
      119,
      101,
      114,
      116,
      121,
      117,
      105,
      111,
      112,
      91,
      93,
      97,
      115,
      100,
      102,
      103,
      104,
      106,
      107,
      108,
      59,
      39,
      122,
      120,
      99,
      118,
      98,
      110,
      109,
      44,
      46,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      81,
      87,
      69,
      82,
      84,
      89,
      85,
      73,
      79,
      80,
      123,
      125,
      65,
      83,
      68,
      70,
      71,
      72,
      74,
      75,
      76,
      58,
      34,
      90,
      88,
      67,
      86,
      66,
      78,
      77,
      60,
      62,
      63,
      "",
    ],
    password: [
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      113,
      119,
      101,
      114,
      116,
      121,
      117,
      105,
      111,
      112,
      91,
      93,
      97,
      115,
      100,
      102,
      103,
      104,
      106,
      107,
      108,
      59,
      39,
      122,
      120,
      99,
      118,
      98,
      110,
      109,
      44,
      46,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      81,
      87,
      69,
      82,
      84,
      89,
      85,
      73,
      79,
      80,
      123,
      125,
      65,
      83,
      68,
      70,
      71,
      72,
      74,
      75,
      76,
      58,
      34,
      90,
      88,
      67,
      86,
      66,
      78,
      77,
      60,
      62,
      63,
      "",
    ],
    hhh: [
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      113,
      119,
      101,
      114,
      116,
      121,
      117,
      105,
      111,
      112,
      91,
      93,
      97,
      115,
      100,
      102,
      103,
      104,
      106,
      107,
      108,
      59,
      39,
      122,
      120,
      99,
      118,
      98,
      110,
      109,
      44,
      46,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      81,
      87,
      69,
      82,
      84,
      89,
      85,
      73,
      79,
      80,
      123,
      125,
      65,
      83,
      68,
      70,
      71,
      72,
      74,
      75,
      76,
      58,
      34,
      90,
      88,
      67,
      86,
      66,
      78,
      77,
      60,
      62,
      63,
      "",
    ],
    ichveulebrivi: [
      109,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      109,
      111,
      116,
      104,
      110,
      46,
      101,
      98,
      106,
      103,
      91,
      93,
      102,
      99,
      108,
      97,
      117,
      63,
      93,
      114,
      107,
      57,
      39,
      112,
      123,
      119,
      100,
      44,
      121,
      118,
      55,
      56,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      81,
      122,
      69,
      82,
      115,
      89,
      85,
      73,
      79,
      80,
      123,
      125,
      65,
      105,
      68,
      70,
      71,
      72,
      59,
      75,
      76,
      53,
      34,
      38,
      88,
      120,
      86,
      66,
      78,
      77,
      60,
      62,
      63,
      "",
    ],
    sylfaen: [
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      113,
      119,
      101,
      114,
      116,
      121,
      117,
      105,
      111,
      112,
      91,
      93,
      97,
      115,
      100,
      102,
      103,
      104,
      106,
      107,
      108,
      59,
      39,
      122,
      120,
      99,
      118,
      98,
      110,
      109,
      44,
      46,
      47,
      1025,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      1049,
      1062,
      1059,
      1050,
      1045,
      1053,
      1043,
      1064,
      1065,
      1047,
      1061,
      1066,
      1060,
      1067,
      1042,
      1040,
      1055,
      1056,
      1054,
      1051,
      1044,
      1046,
      1069,
      1071,
      1063,
      1057,
      1052,
      1048,
      1058,
      1068,
      1041,
      1070,
      46,
      "",
    ],
    ravi: [
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      113,
      119,
      101,
      114,
      116,
      121,
      117,
      105,
      111,
      112,
      91,
      93,
      97,
      115,
      100,
      102,
      103,
      104,
      106,
      107,
      108,
      59,
      39,
      122,
      120,
      99,
      118,
      98,
      110,
      109,
      44,
      46,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      81,
      87,
      69,
      82,
      84,
      89,
      85,
      73,
      79,
      80,
      123,
      125,
      65,
      83,
      68,
      70,
      71,
      72,
      74,
      75,
      76,
      58,
      34,
      90,
      88,
      67,
      86,
      66,
      78,
      77,
      60,
      62,
      63,
      "",
    ],
    giorgi: [
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      113,
      119,
      101,
      114,
      116,
      121,
      117,
      105,
      111,
      112,
      91,
      93,
      97,
      115,
      100,
      102,
      103,
      104,
      106,
      107,
      108,
      59,
      39,
      122,
      120,
      99,
      118,
      98,
      110,
      109,
      44,
      46,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      81,
      87,
      69,
      82,
      84,
      89,
      85,
      73,
      79,
      80,
      123,
      125,
      65,
      83,
      68,
      70,
      71,
      72,
      74,
      75,
      76,
      58,
      34,
      90,
      88,
      67,
      86,
      66,
      78,
      77,
      60,
      62,
      63,
      "",
    ],
    ibw: [
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      176,
      187,
      8212,
      170,
      172,
      178,
      173,
      339,
      164,
      165,
      91,
      93,
      8249,
      171,
      8211,
      175,
      8226,
      191,
      190,
      376,
      161,
      59,
      39,
      353,
      189,
      181,
      732,
      338,
      163,
      162,
      44,
      46,
      47,
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      81,
      188,
      69,
      177,
      8250,
      89,
      85,
      73,
      79,
      80,
      91,
      93,
      65,
      179,
      68,
      70,
      71,
      72,
      166,
      75,
      76,
      59,
      8217,
      186,
      88,
      180,
      86,
      66,
      78,
      77,
      44,
      46,
      63,
      "",
    ],
    MinusKolkheti: [
      1105,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      1081,
      1094,
      1091,
      1082,
      1077,
      1085,
      1075,
      1096,
      1097,
      1079,
      1093,
      1098,
      1092,
      1099,
      1074,
      1072,
      1087,
      1088,
      1086,
      1083,
      1076,
      1078,
      1101,
      92,
      1103,
      1095,
      1089,
      1084,
      1080,
      1090,
      1100,
      1073,
      1102,
      46,
      1025,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      1049,
      1062,
      1059,
      1050,
      1045,
      1053,
      1043,
      1064,
      1065,
      1047,
      1061,
      1066,
      1060,
      1067,
      1042,
      1040,
      1055,
      1056,
      1054,
      1051,
      1044,
      1046,
      1069,
      92,
      1071,
      1063,
      1057,
      1052,
      1048,
      1058,
      1068,
      1041,
      1070,
      46,
      "",
    ],
    test: [
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      113,
      119,
      101,
      114,
      116,
      121,
      117,
      105,
      111,
      112,
      91,
      93,
      97,
      115,
      100,
      102,
      103,
      104,
      106,
      107,
      108,
      59,
      39,
      122,
      120,
      99,
      118,
      98,
      110,
      109,
      44,
      46,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      81,
      87,
      69,
      82,
      84,
      89,
      85,
      73,
      79,
      80,
      123,
      125,
      65,
      83,
      68,
      70,
      71,
      72,
      74,
      75,
      76,
      58,
      34,
      90,
      88,
      67,
      86,
      66,
      78,
      77,
      60,
      62,
      63,
      "",
    ],
    ORIS: [
      39,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      216,
      223,
      196,
      210,
      212,
      218,
      214,
      201,
      207,
      208,
      91,
      93,
      192,
      211,
      195,
      215,
      194,
      228,
      227,
      202,
      203,
      59,
      96,
      198,
      225,
      221,
      197,
      193,
      205,
      204,
      44,
      46,
      47,
      32,
      224,
      32,
      217,
      200,
      199,
      206,
      213,
      226,
      229,
      123,
      125,
      32,
      219,
      32,
      32,
      32,
      32,
      209,
      32,
      32,
      58,
      34,
      222,
      32,
      220,
      91,
      93,
      167,
      185,
      60,
      62,
      63,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      "",
    ],
    orrris: [
      39,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      216,
      223,
      196,
      210,
      212,
      218,
      214,
      201,
      207,
      208,
      91,
      93,
      192,
      211,
      195,
      215,
      194,
      228,
      227,
      202,
      203,
      59,
      96,
      198,
      225,
      221,
      197,
      193,
      205,
      204,
      44,
      46,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      81,
      224,
      69,
      217,
      200,
      199,
      206,
      213,
      226,
      229,
      123,
      125,
      65,
      219,
      68,
      70,
      71,
      72,
      209,
      75,
      76,
      58,
      34,
      222,
      88,
      220,
      91,
      93,
      167,
      185,
      60,
      62,
      63,
      "",
    ],
    GeoTimes: [
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      216,
      223,
      196,
      210,
      212,
      218,
      214,
      201,
      207,
      208,
      91,
      93,
      192,
      211,
      195,
      215,
      194,
      228,
      227,
      202,
      203,
      59,
      8217,
      198,
      225,
      221,
      197,
      193,
      205,
      204,
      44,
      46,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      216,
      224,
      199,
      217,
      200,
      218,
      213,
      206,
      229,
      167,
      123,
      125,
      192,
      219,
      195,
      215,
      194,
      199,
      209,
      202,
      166,
      58,
      8221,
      222,
      226,
      220,
      197,
      193,
      78,
      204,
      60,
      62,
      63,
      "",
    ],
    ChveuNusx: [
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      113,
      119,
      101,
      114,
      116,
      121,
      117,
      105,
      111,
      112,
      91,
      93,
      97,
      115,
      100,
      102,
      103,
      104,
      106,
      107,
      108,
      59,
      39,
      122,
      120,
      99,
      118,
      98,
      110,
      109,
      44,
      46,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      81,
      87,
      69,
      82,
      84,
      89,
      85,
      73,
      79,
      80,
      123,
      125,
      65,
      83,
      68,
      70,
      71,
      72,
      74,
      75,
      76,
      58,
      34,
      90,
      88,
      67,
      86,
      66,
      78,
      77,
      60,
      62,
      63,
      "",
    ],
    Ventura: [
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      113,
      119,
      101,
      114,
      116,
      121,
      117,
      105,
      111,
      112,
      91,
      93,
      97,
      115,
      100,
      102,
      103,
      104,
      106,
      107,
      108,
      59,
      39,
      122,
      120,
      99,
      118,
      98,
      110,
      109,
      44,
      46,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      81,
      87,
      69,
      82,
      84,
      89,
      85,
      73,
      79,
      80,
      123,
      125,
      65,
      83,
      68,
      70,
      71,
      72,
      74,
      75,
      76,
      58,
      34,
      90,
      88,
      67,
      86,
      66,
      78,
      77,
      60,
      62,
      63,
      "",
    ],
    dato: [
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      113,
      119,
      101,
      114,
      116,
      121,
      117,
      105,
      111,
      112,
      91,
      93,
      97,
      115,
      100,
      102,
      103,
      104,
      106,
      107,
      108,
      59,
      39,
      122,
      120,
      99,
      118,
      98,
      110,
      109,
      44,
      46,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      81,
      87,
      69,
      82,
      84,
      89,
      85,
      73,
      79,
      80,
      123,
      125,
      65,
      83,
      68,
      70,
      71,
      72,
      74,
      75,
      76,
      58,
      34,
      90,
      88,
      67,
      86,
      66,
      78,
      77,
      60,
      62,
      63,
      "",
    ],
    eng: [
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      113,
      119,
      101,
      114,
      116,
      121,
      117,
      105,
      111,
      112,
      91,
      93,
      97,
      115,
      100,
      102,
      103,
      104,
      106,
      107,
      108,
      59,
      39,
      122,
      120,
      99,
      118,
      98,
      110,
      109,
      44,
      46,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      81,
      87,
      69,
      82,
      84,
      89,
      85,
      73,
      79,
      80,
      123,
      125,
      65,
      83,
      68,
      70,
      71,
      72,
      74,
      75,
      76,
      58,
      34,
      90,
      88,
      67,
      86,
      66,
      78,
      77,
      60,
      62,
      63,
      "",
    ],
    li: [
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      213,
      220,
      196,
      208,
      210,
      121,
      211,
      200,
      205,
      112,
      91,
      93,
      192,
      209,
      195,
      212,
      194,
      104,
      223,
      201,
      202,
      59,
      39,
      198,
      222,
      218,
      197,
      193,
      204,
      203,
      44,
      46,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      81,
      87,
      69,
      82,
      199,
      89,
      85,
      73,
      79,
      80,
      123,
      125,
      65,
      216,
      68,
      70,
      71,
      72,
      74,
      75,
      76,
      58,
      34,
      219,
      88,
      67,
      86,
      66,
      78,
      77,
      60,
      62,
      63,
      "",
    ],
    zzzKolkhety: [
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      225,
      249,
      229,
      238,
      252,
      241,
      243,
      242,
      235,
      240,
      91,
      93,
      239,
      236,
      230,
      244,
      227,
      184,
      246,
      234,
      228,
      59,
      39,
      231,
      245,
      250,
      226,
      254,
      237,
      232,
      44,
      46,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      81,
      255,
      69,
      233,
      224,
      89,
      85,
      73,
      79,
      80,
      123,
      125,
      65,
      248,
      68,
      70,
      71,
      72,
      253,
      75,
      76,
      58,
      34,
      251,
      88,
      247,
      86,
      66,
      78,
      77,
      60,
      62,
      63,
      "",
    ],
    Orisrus: [
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      1064,
      1071,
      1044,
      1058,
      1060,
      1066,
      1062,
      1049,
      1055,
      1056,
      91,
      93,
      1040,
      1059,
      1043,
      1063,
      1042,
      1076,
      1075,
      1050,
      1051,
      59,
      96,
      1046,
      1073,
      1069,
      1045,
      1041,
      1053,
      1052,
      44,
      46,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      32,
      1072,
      32,
      1065,
      1048,
      1047,
      1054,
      1061,
      1074,
      1077,
      123,
      125,
      32,
      1067,
      32,
      32,
      32,
      32,
      1057,
      32,
      32,
      58,
      34,
      1070,
      32,
      1068,
      91,
      93,
      167,
      8470,
      60,
      62,
      63,
      "",
    ],
    LUT: [
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      1092,
      1099,
      1076,
      1087,
      1089,
      1094,
      1090,
      1079,
      1084,
      1085,
      91,
      93,
      1072,
      1088,
      1075,
      1091,
      1074,
      1103,
      1102,
      1080,
      1081,
      59,
      39,
      1105,
      1101,
      1097,
      1077,
      1073,
      1083,
      1082,
      44,
      46,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      81,
      1100,
      69,
      1093,
      1078,
      89,
      85,
      73,
      79,
      80,
      123,
      125,
      65,
      1095,
      68,
      70,
      71,
      72,
      1086,
      75,
      76,
      58,
      34,
      1098,
      88,
      1096,
      86,
      66,
      78,
      77,
      60,
      62,
      63,
      "",
    ],
    GeorgianSPLat: [
      8222,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      216,
      223,
      196,
      210,
      212,
      218,
      214,
      201,
      207,
      208,
      91,
      93,
      192,
      211,
      195,
      215,
      194,
      228,
      227,
      202,
      203,
      59,
      39,
      198,
      225,
      221,
      197,
      193,
      205,
      204,
      44,
      46,
      47,
      8220,
      33,
      64,
      185,
      167,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      32,
      224,
      32,
      217,
      200,
      32,
      32,
      206,
      32,
      32,
      123,
      125,
      32,
      219,
      32,
      32,
      32,
      32,
      209,
      32,
      32,
      58,
      34,
      222,
      226,
      220,
      213,
      32,
      78,
      32,
      60,
      62,
      63,
      "",
    ],
    sacdeli: [
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      113,
      119,
      101,
      114,
      116,
      121,
      117,
      105,
      111,
      112,
      91,
      93,
      97,
      115,
      100,
      102,
      103,
      104,
      106,
      107,
      108,
      59,
      39,
      122,
      120,
      99,
      118,
      98,
      110,
      109,
      44,
      46,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      81,
      87,
      69,
      82,
      84,
      89,
      85,
      73,
      79,
      80,
      123,
      125,
      65,
      83,
      68,
      70,
      71,
      72,
      74,
      75,
      76,
      58,
      34,
      90,
      88,
      67,
      86,
      66,
      78,
      77,
      60,
      62,
      63,
      "",
    ],
    dacomutf: [
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      113,
      119,
      101,
      114,
      116,
      121,
      117,
      105,
      111,
      112,
      91,
      93,
      97,
      115,
      100,
      102,
      103,
      104,
      106,
      107,
      108,
      59,
      39,
      122,
      120,
      99,
      118,
      98,
      110,
      109,
      44,
      46,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      81,
      87,
      69,
      82,
      84,
      89,
      85,
      73,
      79,
      80,
      123,
      125,
      65,
      83,
      68,
      70,
      71,
      72,
      74,
      75,
      76,
      58,
      34,
      90,
      88,
      67,
      86,
      66,
      78,
      77,
      60,
      62,
      63,
      "",
    ],
    sylifaen: [
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      113,
      119,
      101,
      114,
      116,
      121,
      117,
      105,
      111,
      112,
      91,
      93,
      97,
      115,
      100,
      102,
      103,
      104,
      106,
      107,
      108,
      59,
      39,
      122,
      120,
      99,
      118,
      98,
      110,
      109,
      44,
      46,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      81,
      87,
      69,
      82,
      84,
      89,
      85,
      73,
      79,
      80,
      123,
      125,
      65,
      83,
      68,
      70,
      71,
      72,
      74,
      75,
      76,
      58,
      34,
      90,
      88,
      67,
      86,
      66,
      78,
      77,
      60,
      62,
      63,
      "",
    ],
    Kolkhi: [
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      113,
      119,
      101,
      114,
      116,
      121,
      117,
      105,
      111,
      112,
      91,
      93,
      97,
      115,
      100,
      102,
      103,
      104,
      106,
      107,
      108,
      59,
      8217,
      122,
      120,
      99,
      118,
      98,
      110,
      109,
      44,
      46,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      81,
      87,
      69,
      82,
      84,
      89,
      85,
      73,
      79,
      80,
      123,
      125,
      65,
      83,
      68,
      70,
      71,
      72,
      74,
      75,
      76,
      58,
      8221,
      90,
      88,
      67,
      86,
      66,
      78,
      77,
      60,
      62,
      63,
      "",
    ],
    georgian: [
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      113,
      119,
      101,
      114,
      116,
      121,
      117,
      105,
      111,
      112,
      91,
      93,
      97,
      115,
      100,
      102,
      103,
      104,
      106,
      107,
      108,
      59,
      39,
      122,
      120,
      99,
      118,
      98,
      110,
      109,
      44,
      46,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      81,
      87,
      69,
      82,
      84,
      89,
      85,
      73,
      79,
      80,
      123,
      125,
      65,
      83,
      68,
      70,
      71,
      72,
      74,
      75,
      76,
      58,
      34,
      90,
      88,
      67,
      86,
      66,
      78,
      77,
      60,
      62,
      63,
      "",
    ],
    literaturulyAV: [
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      109,
      111,
      116,
      104,
      110,
      46,
      101,
      98,
      106,
      103,
      91,
      93,
      102,
      99,
      108,
      97,
      117,
      47,
      93,
      114,
      107,
      59,
      39,
      112,
      91,
      119,
      100,
      44,
      121,
      118,
      44,
      42,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      122,
      87,
      69,
      113,
      115,
      89,
      85,
      73,
      79,
      80,
      123,
      125,
      65,
      105,
      68,
      70,
      71,
      72,
      59,
      75,
      76,
      58,
      34,
      39,
      88,
      120,
      86,
      66,
      78,
      77,
      60,
      62,
      63,
      "",
    ],
    literaturulyAVMTAVR: [
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      46,
      57,
      48,
      45,
      61,
      92,
      77,
      79,
      84,
      72,
      78,
      62,
      69,
      66,
      74,
      71,
      91,
      93,
      70,
      67,
      76,
      65,
      85,
      63,
      125,
      82,
      75,
      59,
      39,
      80,
      123,
      87,
      68,
      60,
      89,
      86,
      44,
      56,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      42,
      90,
      42,
      81,
      83,
      42,
      42,
      42,
      42,
      42,
      123,
      125,
      42,
      73,
      42,
      71,
      42,
      58,
      65,
      42,
      42,
      42,
      42,
      34,
      42,
      88,
      42,
      42,
      42,
      42,
      42,
      42,
      63,
      "",
    ],
    LitNusx: [
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      113,
      119,
      101,
      114,
      116,
      121,
      117,
      105,
      111,
      112,
      91,
      93,
      97,
      115,
      100,
      102,
      103,
      104,
      106,
      107,
      108,
      59,
      39,
      122,
      120,
      99,
      118,
      98,
      110,
      109,
      44,
      46,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      81,
      87,
      69,
      82,
      84,
      89,
      85,
      73,
      79,
      80,
      123,
      125,
      65,
      83,
      68,
      70,
      71,
      72,
      74,
      75,
      76,
      58,
      34,
      90,
      88,
      67,
      86,
      66,
      78,
      77,
      60,
      62,
      63,
      "",
    ],
    Gaugebari: [
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      1061,
      1068,
      1044,
      1056,
      1058,
      1063,
      1059,
      1048,
      1053,
      1054,
      91,
      93,
      1040,
      1057,
      1043,
      1060,
      1042,
      1101,
      1071,
      1049,
      1050,
      59,
      39,
      1046,
      1070,
      1066,
      1045,
      1041,
      1052,
      1051,
      44,
      46,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      113,
      1069,
      69,
      1062,
      1047,
      89,
      85,
      73,
      79,
      80,
      123,
      125,
      65,
      1064,
      68,
      70,
      71,
      72,
      1055,
      75,
      76,
      58,
      34,
      1067,
      88,
      1065,
      86,
      66,
      78,
      77,
      60,
      62,
      63,
      "",
    ],
    GeoArial: [
      92,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      126,
      216,
      223,
      196,
      210,
      212,
      218,
      214,
      201,
      207,
      208,
      91,
      93,
      192,
      211,
      195,
      215,
      194,
      228,
      227,
      202,
      203,
      59,
      96,
      198,
      225,
      221,
      197,
      193,
      205,
      204,
      44,
      46,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      216,
      224,
      196,
      217,
      200,
      199,
      214,
      213,
      226,
      229,
      123,
      125,
      192,
      219,
      195,
      215,
      194,
      228,
      209,
      202,
      203,
      58,
      34,
      222,
      225,
      220,
      197,
      193,
      78,
      204,
      60,
      62,
      63,
      "",
    ],
    Nagdi: [
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      113,
      119,
      101,
      114,
      116,
      121,
      117,
      105,
      111,
      112,
      91,
      93,
      97,
      115,
      100,
      102,
      103,
      104,
      106,
      107,
      108,
      59,
      39,
      122,
      120,
      99,
      118,
      98,
      110,
      109,
      44,
      46,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      81,
      87,
      69,
      82,
      84,
      89,
      85,
      73,
      79,
      80,
      123,
      125,
      65,
      83,
      68,
      70,
      71,
      72,
      74,
      75,
      76,
      58,
      34,
      90,
      88,
      67,
      86,
      66,
      78,
      77,
      60,
      62,
      63,
      "",
    ],
    tmptmp: [
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      113,
      119,
      101,
      114,
      116,
      121,
      117,
      105,
      111,
      112,
      91,
      93,
      97,
      115,
      100,
      102,
      103,
      104,
      106,
      107,
      108,
      59,
      39,
      122,
      120,
      99,
      118,
      98,
      110,
      109,
      44,
      46,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      81,
      87,
      69,
      82,
      84,
      89,
      85,
      73,
      79,
      80,
      123,
      125,
      65,
      83,
      68,
      70,
      71,
      72,
      74,
      75,
      76,
      58,
      34,
      90,
      88,
      67,
      86,
      66,
      78,
      77,
      60,
      62,
      63,
      "",
    ],
    FI: [
      39,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      216,
      223,
      196,
      210,
      212,
      218,
      214,
      201,
      207,
      208,
      91,
      93,
      192,
      211,
      195,
      215,
      194,
      228,
      227,
      202,
      203,
      59,
      96,
      198,
      225,
      221,
      197,
      193,
      205,
      204,
      44,
      46,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      32,
      224,
      32,
      217,
      200,
      199,
      206,
      213,
      226,
      229,
      123,
      125,
      32,
      219,
      32,
      32,
      32,
      32,
      209,
      32,
      32,
      58,
      34,
      222,
      32,
      220,
      91,
      93,
      167,
      185,
      60,
      62,
      63,
      "",
    ],
    KolkhetiTeleType: [
      63,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      43,
      43,
      44,
      111,
      116,
      106,
      109,
      99,
      101,
      110,
      107,
      104,
      43,
      43,
      103,
      118,
      59,
      97,
      117,
      47,
      119,
      114,
      108,
      92,
      129,
      112,
      91,
      93,
      100,
      46,
      121,
      98,
      61,
      38,
      95,
      63,
      96,
      164,
      63,
      167,
      37,
      63,
      63,
      41,
      126,
      124,
      64,
      177,
      166,
      60,
      122,
      84,
      113,
      102,
      67,
      69,
      78,
      75,
      72,
      79,
      85,
      71,
      105,
      58,
      65,
      85,
      63,
      39,
      82,
      76,
      94,
      36,
      115,
      91,
      120,
      68,
      62,
      89,
      66,
      65,
      63,
      33,
      "",
    ],
    azaazaza: [
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      113,
      119,
      101,
      114,
      116,
      121,
      117,
      105,
      111,
      112,
      91,
      93,
      97,
      115,
      100,
      102,
      103,
      104,
      106,
      107,
      108,
      59,
      39,
      122,
      120,
      99,
      118,
      98,
      110,
      109,
      44,
      46,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      81,
      87,
      69,
      82,
      84,
      89,
      85,
      73,
      79,
      80,
      123,
      125,
      65,
      83,
      68,
      70,
      71,
      72,
      74,
      75,
      76,
      58,
      34,
      90,
      88,
      67,
      86,
      66,
      78,
      77,
      60,
      62,
      63,
      "",
    ],
    lat: [
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      113,
      119,
      101,
      114,
      116,
      121,
      117,
      105,
      111,
      112,
      91,
      93,
      97,
      115,
      100,
      102,
      103,
      104,
      106,
      107,
      108,
      59,
      39,
      122,
      120,
      99,
      118,
      98,
      110,
      109,
      44,
      46,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      81,
      87,
      69,
      82,
      84,
      89,
      85,
      73,
      79,
      80,
      123,
      125,
      65,
      83,
      68,
      70,
      71,
      72,
      74,
      75,
      76,
      58,
      34,
      90,
      88,
      67,
      86,
      66,
      78,
      77,
      60,
      62,
      63,
      "",
    ],
    ANusxuri: [
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      113,
      119,
      101,
      114,
      116,
      121,
      117,
      105,
      111,
      112,
      91,
      93,
      97,
      115,
      100,
      102,
      103,
      104,
      106,
      107,
      108,
      59,
      39,
      122,
      120,
      99,
      118,
      98,
      110,
      109,
      44,
      46,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      81,
      87,
      69,
      82,
      84,
      89,
      85,
      73,
      79,
      80,
      123,
      125,
      65,
      83,
      68,
      70,
      71,
      72,
      74,
      75,
      76,
      58,
      34,
      90,
      88,
      67,
      86,
      66,
      78,
      77,
      60,
      62,
      63,
      "",
    ],
    fuchlugi: [
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      113,
      119,
      101,
      114,
      116,
      121,
      117,
      105,
      111,
      112,
      91,
      93,
      97,
      115,
      100,
      102,
      103,
      104,
      106,
      107,
      108,
      59,
      39,
      122,
      120,
      99,
      118,
      98,
      110,
      109,
      44,
      46,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      81,
      87,
      69,
      82,
      84,
      89,
      85,
      73,
      79,
      80,
      123,
      125,
      65,
      83,
      68,
      70,
      71,
      72,
      74,
      75,
      76,
      58,
      34,
      90,
      88,
      67,
      86,
      66,
      78,
      77,
      60,
      62,
      63,
      "",
    ],
    IPTVGeoOld: [
      32,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      113,
      119,
      101,
      114,
      116,
      121,
      117,
      105,
      111,
      112,
      91,
      93,
      97,
      115,
      100,
      102,
      103,
      104,
      106,
      107,
      108,
      59,
      39,
      122,
      120,
      99,
      118,
      98,
      110,
      109,
      44,
      46,
      47,
      32,
      33,
      64,
      35,
      36,
      37,
      32,
      38,
      42,
      40,
      41,
      32,
      43,
      32,
      81,
      94,
      69,
      125,
      123,
      89,
      85,
      73,
      79,
      80,
      32,
      32,
      65,
      126,
      68,
      70,
      71,
      72,
      124,
      75,
      76,
      58,
      34,
      95,
      88,
      96,
      86,
      66,
      78,
      77,
      60,
      62,
      63,
      "",
    ],
    IPTVGeo: [
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      112,
      119,
      95,
      107,
      109,
      114,
      110,
      99,
      104,
      105,
      125,
      126,
      91,
      108,
      94,
      111,
      93,
      123,
      122,
      100,
      101,
      59,
      39,
      97,
      121,
      117,
      96,
      92,
      103,
      102,
      44,
      46,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      81,
      120,
      69,
      113,
      98,
      89,
      85,
      73,
      79,
      80,
      123,
      125,
      65,
      115,
      68,
      70,
      71,
      72,
      106,
      75,
      76,
      58,
      34,
      118,
      88,
      116,
      86,
      66,
      78,
      77,
      60,
      62,
      63,
      "",
    ],
    Hejsannn: [
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      113,
      119,
      101,
      114,
      116,
      121,
      117,
      105,
      111,
      112,
      91,
      93,
      97,
      115,
      100,
      102,
      103,
      104,
      106,
      107,
      108,
      59,
      39,
      122,
      120,
      99,
      118,
      98,
      110,
      109,
      44,
      46,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      81,
      87,
      69,
      82,
      84,
      89,
      85,
      73,
      79,
      80,
      123,
      125,
      65,
      83,
      68,
      70,
      71,
      72,
      74,
      75,
      76,
      58,
      187,
      90,
      88,
      67,
      86,
      66,
      78,
      77,
      60,
      62,
      63,
      "",
    ],
    sylfaenG: [
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      113,
      119,
      101,
      114,
      116,
      121,
      117,
      105,
      111,
      112,
      91,
      93,
      97,
      115,
      100,
      102,
      103,
      104,
      106,
      107,
      108,
      59,
      39,
      122,
      120,
      99,
      118,
      98,
      110,
      109,
      44,
      46,
      47,
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      81,
      87,
      69,
      82,
      84,
      89,
      85,
      73,
      79,
      80,
      91,
      93,
      65,
      83,
      68,
      70,
      71,
      72,
      74,
      75,
      76,
      59,
      39,
      90,
      88,
      67,
      86,
      66,
      78,
      77,
      44,
      46,
      47,
      "",
    ],
    Dumbadze: [
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      113,
      119,
      101,
      114,
      116,
      121,
      117,
      105,
      111,
      112,
      91,
      93,
      97,
      115,
      100,
      102,
      103,
      104,
      106,
      107,
      108,
      59,
      39,
      122,
      120,
      99,
      118,
      98,
      110,
      109,
      44,
      46,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      81,
      87,
      69,
      82,
      84,
      89,
      85,
      73,
      79,
      80,
      123,
      125,
      65,
      83,
      68,
      70,
      71,
      72,
      74,
      75,
      76,
      58,
      34,
      90,
      88,
      67,
      86,
      66,
      78,
      77,
      60,
      62,
      63,
      "",
    ],
    rarus: [
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      167,
      177,
      8230,
      8482,
      160,
      171,
      164,
      8249,
      8226,
      8211,
      91,
      93,
      96,
      8250,
      8222,
      166,
      8218,
      187,
      183,
      8216,
      8217,
      59,
      39,
      8225,
      182,
      174,
      8224,
      126,
      8221,
      8220,
      44,
      46,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      81,
      181,
      69,
      169,
      8240,
      89,
      85,
      73,
      79,
      80,
      123,
      125,
      65,
      172,
      68,
      70,
      71,
      72,
      8212,
      75,
      76,
      58,
      34,
      176,
      88,
      173,
      86,
      66,
      78,
      77,
      60,
      62,
      63,
      "",
    ],
    sylfaenn: [
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      113,
      119,
      101,
      114,
      116,
      121,
      117,
      105,
      111,
      112,
      91,
      93,
      97,
      115,
      100,
      102,
      103,
      104,
      106,
      107,
      108,
      59,
      39,
      122,
      120,
      99,
      118,
      98,
      110,
      109,
      44,
      46,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      81,
      87,
      69,
      82,
      84,
      89,
      85,
      73,
      79,
      80,
      123,
      125,
      65,
      83,
      68,
      70,
      71,
      72,
      74,
      75,
      76,
      58,
      34,
      90,
      88,
      67,
      86,
      66,
      78,
      77,
      60,
      62,
      63,
      "",
    ],
    sylfaennn: [
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      4325,
      4332,
      4308,
      4320,
      4322,
      4327,
      4323,
      4312,
      4317,
      4318,
      91,
      93,
      4304,
      4321,
      4307,
      4324,
      4306,
      4336,
      4335,
      4313,
      4314,
      59,
      39,
      4310,
      4334,
      4330,
      4309,
      4305,
      4316,
      4315,
      44,
      46,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      4347,
      4333,
      4342,
      4326,
      4311,
      4337,
      4338,
      4339,
      4340,
      4341,
      123,
      125,
      4304,
      4328,
      4307,
      4324,
      4306,
      4336,
      4319,
      4313,
      4314,
      58,
      34,
      4331,
      4334,
      4329,
      4309,
      4305,
      4316,
      4315,
      60,
      62,
      63,
      "",
    ],
    zoom: [
      39,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      216,
      223,
      196,
      210,
      212,
      218,
      214,
      201,
      207,
      208,
      91,
      93,
      192,
      211,
      195,
      215,
      194,
      228,
      227,
      202,
      203,
      59,
      96,
      198,
      225,
      221,
      197,
      193,
      205,
      204,
      44,
      46,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      32,
      224,
      32,
      217,
      200,
      199,
      206,
      213,
      226,
      229,
      123,
      125,
      32,
      219,
      32,
      32,
      32,
      32,
      209,
      32,
      32,
      58,
      34,
      222,
      32,
      220,
      91,
      93,
      167,
      185,
      60,
      62,
      63,
      "",
    ],
    ACADEMIURIAV: [
      96,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      45,
      32,
      50,
      50,
      109,
      111,
      116,
      104,
      110,
      46,
      101,
      98,
      106,
      103,
      126,
      96,
      102,
      99,
      108,
      97,
      117,
      47,
      93,
      114,
      107,
      57,
      52,
      112,
      91,
      119,
      100,
      44,
      121,
      118,
      55,
      56,
      50,
      32,
      61,
      32,
      49,
      32,
      43,
      32,
      32,
      32,
      126,
      96,
      45,
      32,
      54,
      32,
      90,
      32,
      81,
      32,
      83,
      32,
      32,
      32,
      32,
      32,
      32,
      32,
      73,
      32,
      32,
      32,
      32,
      32,
      59,
      32,
      32,
      53,
      52,
      39,
      32,
      88,
      32,
      32,
      32,
      32,
      48,
      "",
    ],
    Academic: [
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      113,
      119,
      101,
      114,
      116,
      121,
      117,
      105,
      111,
      112,
      91,
      93,
      97,
      115,
      100,
      102,
      103,
      104,
      106,
      107,
      108,
      59,
      39,
      122,
      120,
      99,
      118,
      98,
      110,
      109,
      44,
      46,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      81,
      87,
      69,
      82,
      84,
      89,
      85,
      73,
      79,
      80,
      123,
      125,
      65,
      83,
      68,
      70,
      71,
      72,
      74,
      75,
      76,
      58,
      34,
      90,
      88,
      67,
      86,
      66,
      78,
      77,
      60,
      62,
      63,
      "",
    ],
    SAIDANrusulidan: [
      1105,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      1081,
      1094,
      1091,
      1082,
      1077,
      1085,
      1075,
      1096,
      1097,
      1079,
      1093,
      1098,
      1092,
      1099,
      1074,
      1072,
      1087,
      1088,
      1086,
      1083,
      1076,
      1078,
      1101,
      1103,
      1095,
      1089,
      1084,
      1080,
      1090,
      1100,
      1073,
      1102,
      46,
      1025,
      33,
      34,
      8470,
      59,
      37,
      58,
      63,
      42,
      40,
      41,
      95,
      43,
      47,
      1049,
      1062,
      1059,
      1050,
      1045,
      1053,
      1043,
      1064,
      1065,
      1047,
      1061,
      1066,
      1060,
      1067,
      1042,
      1040,
      1055,
      1056,
      1054,
      1051,
      1044,
      1046,
      1069,
      1071,
      1063,
      1057,
      1052,
      1048,
      1058,
      1068,
      1041,
      1070,
      44,
      "",
    ],
    SADqartunikodze: [
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      113,
      119,
      101,
      114,
      116,
      121,
      117,
      105,
      111,
      112,
      91,
      93,
      97,
      115,
      100,
      102,
      103,
      104,
      106,
      107,
      108,
      59,
      39,
      122,
      120,
      99,
      118,
      98,
      110,
      109,
      44,
      46,
      47,
      4310,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      4314,
      4327,
      4324,
      4315,
      4309,
      4318,
      4307,
      4329,
      4330,
      4312,
      4326,
      4331,
      4325,
      4332,
      4306,
      4304,
      4320,
      4321,
      4319,
      4316,
      4308,
      4311,
      4334,
      4336,
      4328,
      4322,
      4317,
      4313,
      4323,
      4333,
      4305,
      4335,
      63,
      "",
    ],
    Grigolia: [
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      113,
      119,
      101,
      114,
      116,
      121,
      117,
      105,
      111,
      112,
      91,
      93,
      92,
      97,
      115,
      100,
      102,
      103,
      104,
      106,
      107,
      108,
      59,
      39,
      122,
      120,
      99,
      118,
      98,
      110,
      109,
      44,
      46,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      81,
      87,
      69,
      82,
      84,
      89,
      85,
      73,
      79,
      80,
      123,
      125,
      124,
      65,
      83,
      68,
      70,
      71,
      72,
      74,
      75,
      76,
      58,
      34,
      90,
      88,
      67,
      86,
      66,
      78,
      77,
      60,
      62,
      63,
      "",
    ],
    PDFtoENG: [
      192,
      239,
      238,
      237,
      236,
      235,
      234,
      233,
      232,
      231,
      240,
      243,
      227,
      196,
      175,
      169,
      187,
      174,
      172,
      167,
      171,
      183,
      177,
      176,
      197,
      195,
      191,
      173,
      188,
      186,
      185,
      184,
      182,
      181,
      180,
      229,
      249,
      166,
      168,
      189,
      170,
      190,
      178,
      179,
      244,
      242,
      241,
      126,
      255,
      224,
      253,
      252,
      251,
      194,
      250,
      246,
      248,
      247,
      193,
      245,
      124,
      207,
      201,
      219,
      206,
      204,
      199,
      203,
      215,
      209,
      208,
      123,
      125,
      223,
      205,
      220,
      218,
      217,
      216,
      214,
      213,
      212,
      230,
      254,
      198,
      200,
      221,
      202,
      222,
      210,
      211,
      228,
      226,
      225,
      "",
    ],
    New_to_UTF8: [
      96,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      113,
      119,
      101,
      114,
      116,
      121,
      117,
      105,
      111,
      112,
      91,
      93,
      97,
      115,
      100,
      102,
      103,
      104,
      106,
      107,
      108,
      59,
      39,
      122,
      120,
      99,
      118,
      98,
      110,
      109,
      44,
      46,
      47,
      126,
      33,
      64,
      35,
      36,
      37,
      94,
      38,
      42,
      40,
      41,
      95,
      43,
      124,
      81,
      87,
      69,
      82,
      84,
      89,
      85,
      73,
      79,
      80,
      123,
      125,
      65,
      83,
      68,
      70,
      71,
      72,
      74,
      75,
      76,
      58,
      34,
      90,
      88,
      67,
      86,
      66,
      78,
      77,
      60,
      62,
      63,
      "",
    ],
    Tariel_Putkaradze_Transliteration: [
      8222,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      48,
      45,
      61,
      92,
      107,
      267,
      101,
      114,
      355,
      113,
      117,
      105,
      111,
      7767,
      91,
      93,
      97,
      115,
      100,
      112,
      103,
      104,
      106,
      311,
      108,
      59,
      364,
      122,
      295,
      99,
      118,
      98,
      110,
      109,
      44,
      46,
      47,
      293,
      33,
      64,
      35,
      36,
      37,
      165,
      89,
      42,
      40,
      41,
      9472,
      43,
      124,
      81,
      265,
      69,
      287,
      116,
      89,
      85,
      73,
      79,
      7766,
      123,
      125,
      65,
      353,
      68,
      80,
      71,
      72,
      382,
      310,
      76,
      58,
      364,
      309,
      294,
      269,
      86,
      66,
      78,
      77,
      60,
      62,
      63,
      63,
      "",
    ],
  },
  layout1: [
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 43, 22, 18, 31, 42, 45, 16,
    41, 32, 30, 24, 25, 29, 39, 34, 26, 20, 0, 25, 17, 33, 35, 36, 23, 24, 15,
    28, 44, 19, 40, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58,
    59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77,
    78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93,
  ],
  layout2: [
    0, 31, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 39, 20, 33, 16, 42, 30,
    21, 15, 37, 38, 32, 29, 27, 40, 26, 23, 17, 22, 34, 28, 35, 36, 37, 38, 27,
    43, 21, 18, 14, 41, 19, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58,
    59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77,
    78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93,
  ],
};
